import * as React from "react";
import ReactMde from "react-mde";
import * as Showdown from "showdown";
import './markdownEditor.scss'

interface IProps {
	/**
	 * React-mde min preview height.
	 */
	minPreviewHeight?: number;
	/**
	 * React-mde max editor height.
	 */
	maxEditorHeight?: number;
	/**
	 * React-mde min editor height.
	 */
	minEditorHeight?: number;
	/**
	 * On markdown change callback.
	 */
	onChange: (md: string) => void;
	/**
	 * Markdown data.
	 */
	markdown: string;
	/**
	 * Disabled flag for markdown editor.
	 */
	disabled: boolean;
}

/**
 * Extension for injecting inline  styling.
 */
Showdown.extension('styled-elements', function() {

	const styleMap: { [key: string]: string } = {
		h1: 'font-size: 14px; font-weight: bold',
		h2: 'font-size: 14px; font-weight: bold',
		h3: 'font-size: 14px; font-weight: bold',
		h4: 'font-size: 14px; font-weight: bold',
		ul: 'padding-left: 15px; font-size: 14px;line-height: 1.33',
		strong: 'font-size: 14px;',
		em: 'font-size: 14px;',
		del: 'font-size: 14px;',
		img: 'max-width: 470px; display: flex; margin: 0 auto;'
	};

	return Object.keys(styleMap)
		.map(key => ({
			type: 'output',
			regex: new RegExp(`<${key}(.*)>`, 'g'),
			replace: `<${key} style="${styleMap[key]}" $1>`
		}));
});

/**
 * Extension replacing checkboxes list to green check marks icons.
 */
Showdown.extension('check-mark-list', function() {
	return [{
		type: 'output',
		regex: new RegExp(`\<li class="task-list-item" style="list-style-type: none;">`, 'g'),
		replace: '<li style="margin-left: 0;position: relative;list-style-type: none;">'
	}, {
		type: 'output',
		regex: new RegExp(`<input type\=\"checkbox\".*\"\>`, 'g'),
		replace: '<span style="position: absolute; left: -20px; color:#7ed321">✓</span>'
	}
	]
});

export default class MarkdownEditor extends React.Component<IProps, {}> {

	converter: Showdown.Converter;

	public static defaultProps: Partial<IProps> = {
		minPreviewHeight: 150,
		maxEditorHeight: 300,
		minEditorHeight: 150,
	};

	constructor(props: IProps) {
		super(props);
		this.converter = new Showdown.Converter({
			tables: true,
			simplifiedAutoLink: true,
			strikethrough: true,
			tasklists: true,
			extensions: ["styled-elements", "check-mark-list"],
			noHeaderId: true,
		});
	}

	render() {
		return (
			<ReactMde
				className={"c-markdown-editor"}
				onChange={this.props.onChange}
				minPreviewHeight={this.props.minPreviewHeight}
				maxEditorHeight={this.props.maxEditorHeight}
				minEditorHeight={this.props.minEditorHeight}
				value={this.props.markdown}
				readOnly={this.props.disabled}
				generateMarkdownPreview={(markdown: any) =>
					Promise.resolve(this.converter.makeHtml(markdown))
				}
			/>
		);
	}
}